// Work_Process.jsx
import React from "react";
import "./Work_Process.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Work_Process = () => {
  const cards = [
    {
      id: 1,
      icon: "/assets/images/home/work_process/service.png",
      title: "Select a Service",
      subtitle: "Choose your required vehicle service",
      arrow: "/assets/images/home/work_process/arrow1.png",
    },
    {
      id: 2,
      icon: "/assets/images/home/work_process/schedule.png",
      title: "Schedule Pickup/ Appointment",
      subtitle: "Pick a convenient time and location",
      arrow: "/assets/images/home/work_process/arrow2.png",
    },
    {
      id: 3,
      icon: "/assets/images/home/work_process/tracking.png",
      title: "Real-Time Tracking",
      subtitle: "Monitor progress via app or dashboard",
      arrow: "/assets/images/home/work_process/arrow3.png",
    },
    {
      id: 4,
      icon: "/assets/images/home/work_process/delivery.png",
      title: "Doorstep Delivery & Payment",
      subtitle: "Get your vehicle back with secure payment",
     
    },
  ];

  return (
    <section className="work">
      <Common_Title pageTitle="Work Process" boxText="How It Works" />

      <div className="work_process">
        <div className="main_holder">
          {cards.map((card, idx) => (
            <div
              className={`step_with_arrow card_${card.id}`}  
              key={card.id}
            >
           
              <div className="card">
                <div className="card_inner">
                  <img src={card.icon} alt={card.title} className="step_icon" />
                  <h3 className="step_title">{card.title}</h3>
                  <p className="step_subtitle">{card.subtitle}</p>
                </div>
              </div>

            
              {card.arrow && idx < cards.length - 1 && (
                <div className="arrow_holder">
                  <img src={card.arrow} alt="arrow" className="arrow_img" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Work_Process;